__turbopack_context__.v({
  "eyebrow": "insights-pane-module-scss-module__pmodOW__eyebrow",
  "heading": "insights-pane-module-scss-module__pmodOW__heading",
  "intro": "insights-pane-module-scss-module__pmodOW__intro",
  "introMeta": "insights-pane-module-scss-module__pmodOW__introMeta",
  "introSummary": "insights-pane-module-scss-module__pmodOW__introSummary",
  "root": "insights-pane-module-scss-module__pmodOW__root",
  "scroll": "insights-pane-module-scss-module__pmodOW__scroll",
  "sections": "insights-pane-module-scss-module__pmodOW__sections",
});
